/**
 * @return {string}
 */
const AdminTitle = function () {
    return 'Криптолекция 239. Авторизация'
};
module.exports.AdminTitle = AdminTitle;

const AddLangLink = function () {
    return {ru: '/ru', en: '', cn: '/cn'}
};
module.exports.AddLangLink = AddLangLink;

const NewsDopInfo = function () { // Эта настройка создает возможность менять данные для админки раздел Новости. К примеру, у кого-то из клиентов есть доп. поля, которые надо настраивать в админке
    return {Exist: false, Name: 'Картинка для страницы'}
};
module.exports.NewsDopInfo = NewsDopInfo;

/**
 * @return {string}
 */
const MonthToText = function (Month,lang) {
    const AllMonth = {
        ru: ['ЯНВАРЯ','ФЕВРАЛЯ','МАРТА','АПРЕЛЯ','МАЯ','ИЮНЯ','ИЮЛЯ','АВГУСТА','СЕНТЯБРЯ','ОКТЯБРЯ','НОЯБРЯ','ДЕКАБРЯ'],
        en:  ['January','February','March','April','May','June','July','August','September','October','November','December'],
        cn: ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]
};
    const MonthLang = (AllMonth[lang] ? AllMonth[lang] :  AllMonth.en);
    return MonthLang[+Month-1];
};
module.exports.MonthToText = MonthToText;

